import api from '../api'

class SubscriptionService {

  static getClientSecretStripe() {
		return api({
			method: 'post',
			url: 'client-secret-stripe',
			data: { ref: 'subscription'}
		})
  }

  static storeSubscription(data) {
		return api({
			method: 'post',
			url: 'subscriptions',
			data
		})
  }

  static updateSubscription(data) {
    return api({
      method: 'put',
      url: 'subscriptions',
      data
    })
  }

}

export default SubscriptionService
